module.exports = __webpack_public_path__ + "img/logout.ee66d699.svg";